<div>
  <div class="mb-4 flex items-center justify-between">
    <p class="font-bold">Comparing Current(LRE) Budget to {{ snapshotName$ | async }}</p>
    <div class="flex space-x-4 text-sm">
      <div class="flex items-center">
        <span>Compare from</span>
        <ng-select
          class="ml-4 w-28"
          [items]="fromRange"
          bindValue="value"
          bindLabel="label"
          [clearable]="false"
          [searchable]="false"
          [formControl]="fromDateControl"
        />
      </div>
      <div class="flex items-center">
        <span>To</span>
        <ng-select
          class="ml-4 w-28"
          [items]="toRange"
          bindValue="value"
          bindLabel="label"
          [clearable]="false"
          [searchable]="false"
          [formControl]="toDateControl"
        />
      </div>
    </div>
  </div>

  <div class="grid grid-cols-4">
    @for (card of analyticCards$ | async; track card) {
      <aux-trial-insights-finance-analytic-card [data]="card" />
    }
    <div class="col-span-4 border-x border-b border-aux-gray-dark py-1 text-center">
      <a [routerLink]="budgetLink" class="btn--hyperlink">View Vendor Budget</a>
    </div>
  </div>
</div>
